import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { setClassNameInDefns } from '../../common/definitionHelper';
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdBox from '../../common/elemental/AfitdBox';
import { nl2br } from '../../common/textHelper';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <AfitdBox p={3}>{children}</AfitdBox>}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 0,
        marginTop: 30,
        '& .MuiBox-root': { paddingLeft: '0px', paddingRight: '0px' },
        '& .Mui-selected': { color: '#1D8A8B' },
        '& .MuiTabs-indicator': { height: '4px' },
        '& .MuiTabs-flexContainer': { borderBottom: '1px solid #F0F2F6' },
        '& .MuiTabs-flexContainer .MuiButtonBase-root': { marginRight: '30px', padding: 0, minWidth: '3rem' },
    },
    tabTitle: {
        fontSize: '18px',
        color: '#000',
        marginBottom: 5,
        letterSpacing: 0,
        fontWeight: 600,
        textAlign: 'right',
        '& span:nth-of-type(1)': { textTransform: 'capitalize !important' },
    },
    buttonBox: { display: 'flex', justifyContent: 'space-between', marginBottom: 20 },
    content: {
        maxHeight: 250,
        [theme.breakpoints.down('lg')]: {
            maxHeight: 100,
        },
        overflowY: 'scroll',
        '&::-webkit-scrollbar': { width: '0.4em' },
        '&::-webkit-scrollbar-track': { '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)' },
        '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,.1)', borderRadius: '5px' },
        // [theme.breakpoints.down('sm')]: { paddingBottom: 270 },
    },
    paragraph: { marginBottom: '20px', wordBreak: 'break-word' },
}));
const getDefns = params => {
    const { classes, value, changeTabHandler } = params;
    const defns = {
        appBar: {
            position: 'static',
            style: { background: '#fff' },
            elevation: 0,
        },
        tabs: {
            value,
            onChange: changeTabHandler,
            'aria-label': 'simple tabs example',
        },
        paragraph: { variant: 'body2', component: 'div' },
    };
    // inject classes
    setClassNameInDefns(defns, classes);
    return defns;
};
export default function SimpleTabs(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const { jobDescription = '', benefitSummary = '', companyBio = '' } = props;

    const defns = getDefns({ classes, value, changeTabHandler: handleChange, props });

    return (
        <div {...defns.root}>
            <AppBar {...defns.appBar}>
                <Tabs {...defns.tabs}>
                    <Tab label="Description" {...a11yProps(0)} className={classes.tabTitle} />
                    <Tab label="Benefits" {...a11yProps(1)} className={classes.tabTitle} />
                    <Tab label="Company" {...a11yProps(2)} className={classes.tabTitle} />
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0}>
                <div {...defns.content}>
                    <AfitdTypography {...defns.paragraph}>{nl2br(jobDescription)}</AfitdTypography>
                </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <div {...defns.content}>
                    <AfitdTypography {...defns.paragraph}>{nl2br(benefitSummary)}</AfitdTypography>
                </div>
            </TabPanel>
            <TabPanel value={value} index={2}>
                <div {...defns.content}>
                    <AfitdTypography {...defns.paragraph}>{nl2br(companyBio)}</AfitdTypography>
                </div>
            </TabPanel>
        </div>
    );
}
